import React from 'react';
import { Spring, animated } from 'react-spring';
import { agda, agency, best, bima, fwa, webstock } from './images/index';
import styles from './style.css';

const Certifications = () => (
  <div className={styles.certifications}>
    <Spring
      native
      from={{ opacity: 0, transform: 'translateX(-50%)' }}
      to={{ opacity: 1, transform: 'translateX(0%)' }}
    >
      {style => (
        <animated.div style={style} className={styles.certifications__text}>
          Work in Progress is one of the only 50 certified agencies worldwide
          cherry-picked by Google.
        </animated.div>
      )}
    </Spring>

    <div className={styles.certifications__logos__wrapper}>
      <Spring delay={500} native from={{ opacity: 0 }} to={{ opacity: 1 }}>
        {style => (
          <animated.div style={style} className={styles.certifications__logos}>
            <div
              id={styles.google__agency}
              className={styles.certifications__logos__item}
            >
              <img
                width="129"
                src={agency}
                alt="Google Developers Agency Program: 2018 Certified Agency - Android"
              />
            </div>
            <div className={styles.certifications__logos__item}>
              <img width="76" src={fwa} alt="The FWA Awards" />
            </div>
            <div className={styles.certifications__logos__item}>
              <img width="80" src={bima} alt="BIMA Awards" />
            </div>
            <div className={styles.certifications__logos__item}>
              <img width="60" src={best} alt="Best Awards" />
            </div>
            <div className={styles.certifications__logos__item}>
              <img width="68" src={agda} alt="AGDA Design Awards" />
            </div>
            <div className={styles.certifications__logos__item}>
              <img width="80" src={webstock} alt="Webstock Awards" />
            </div>
          </animated.div>
        )}
      </Spring>
    </div>
  </div>
);

export default Certifications;
